import axios from "axios";
import config from "../config";

const LOGGING_BASE_URL = `${config.API_BASE_URL}/api/v1`;

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");

  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

const loggerApi = axios.create({
  baseURL: LOGGING_BASE_URL,
});

export const startAction = async (payload) => {
  const response = await loggerApi.post("/action/start", payload, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const updateAction = async (actionId, payload) => {
  if (!actionId) return null;

  const response = await loggerApi.put(`/action/${actionId}/update`, payload, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const completeAction = async (actionId, payload) => {
  if (!actionId) return null;

  const response = await loggerApi.put(
    `/action/${actionId}/complete`,
    payload,
    {
      headers: getAuthHeaders(),
    },
  );
  return response.data;
};
